import { KPlayerResource, KResource } from '@envclient/envengine/src/envs/koenigsburg/KResource';
import React from 'react';
import classes from './KPlayerResourceItem.module.scss';
import { KResourceItem } from './KResourceItem';
import { CSSPos } from '../../types/frontendTypes';

type Props = {
  playerResource: KPlayerResource;
  pos?: CSSPos;
};
export const KPlayerResourceItem = (props: Props) => {
  const { playerResource, pos } = props;

  const finalStyle: CSSPos = { ...pos };

  return (
    <div className={classes.playerResource} style={finalStyle}>
      {Array.from(playerResource.map.values()).map((resource: KResource, index) => {
        const left = index * 42;
        return <KResourceItem key={resource.id} resource={resource} pos={{ top: 0, left }} />;
      })}
    </div>
  );
};
